import Vue from 'vue';
import VueRouter from 'vue-router';
import InstantSearch from 'vue-instantsearch';
import { EventBus, Http, Auth, GraphQlClient, VueCookies } from '@intelipost-js/secure-providers';
import { ScToast, ScDialog } from '@intelipost-js/secure-components';
import SecureUi from '@intelipost-js/secure-ui';
import Hotjar from '@hotjar/browser';
import '@intelipost-js/secure-ui/secure-ui.css';
import App from './App';
import router from './router';
import store from './store';
import './session';

GraphQlClient.setUri(process.env.GRAPHQL_URL);
Http.setBaseUrl(process.env.API_URL);
Http.setInterceptorRequest((request) => {
  if (request.baseURL === process.env.API_URL) {
    Object.assign(request.headers, {
      platform: 'intelipost-frontend',
      production: false,
      debug: false,
    });

    if (Auth.isAuth()) {
      const { is_production, debug, access_token, token } = Auth.getUser();
      if (token) {
        Object.assign(request.headers, {
          token,
          production: !!is_production,
          debug: !!debug,
        });
      } else {
        Object.assign(request.headers, {
          Authorization: `Bearer ${access_token}`,
          production: !!is_production,
          debug: !!debug,
        });
      }
    }
  }

  return request;
}, error => Promise.reject(error));

Vue.config.productionTip = process.env.NODE_ENV === 'production';
Vue.prototype.$http = Http;
Vue.prototype.$bus = EventBus;
Vue.prototype.$instance = Vue;
Vue.prototype.$appVersion = require('../package.json').version;

EventBus.$on('toast', (event) => {
  const { type = 'info', message = null } = event;

  if (message) {
    if (ScToast[type]) {
      ScToast[type](message);
    } else {
      ScToast.open({ message });
    }
  }
});


const siteId = 3320192;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

EventBus.$on('dialog', event => ScDialog.alert(event));

Vue.use(SecureUi);
Vue.use(VueRouter);
Vue.use(InstantSearch);
Vue.use(VueCookies);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js